(function (angular) {
  "use strict";

  var TOOLTIP_FADEOUT_DURATION_MS = 600;
  var MOUSE_LEAVE_TOOLTIP_CLOSE_DELAY_MS = 200;
  var TOOLTIP_CALLOUT_BOX_VIEWPORT_MARGIN = 30;
  var TOOLTIP_CALLOUT_NUB_WIDTH = 13;
  var TOOLTIP_CALLOUT_BOX_BORDER_RADIUS = 3;

  angular.module("Toyota.Directives").directive("tyTooltipCallout", [
    "$rootScope",
    "CssMediaWatcher",
    "$window",
    "$timeout",
    "GenerateUuid",
    function ($rootScope, CssMediaWatcher, $window, $timeout, GenerateUuid) {
      // prettier-ignore
      var template =
        '<div class="ty-tooltip-callout" data-ng-show="ctl.isOpen" data-ng-class="{ \'has-close-button\': !ctl.isMouseDetected }">' +
          '<span class="ty-tooltip-callout__internal-origin"></span>' +
          '<span class="ty-tooltip-callout__nub-fill"></span>' +
          '<span class="ty-tooltip-callout__nub-border-and-shadow"></span>' +
          '<div class="ty-tooltip-callout__box">' +
            '<span class="ty-tooltip-callout__close" data-ng-if="!ctl.isMouseDetected" data-ng-click="ctl.close();">' +
              '<ty-svg-icon icon-id="close" icon-width="16px" icon-height="16px"></ty-svg-icon>' +
            "</span>" +
            '<div class="ty-tooltip-callout__content">' +
              "<ng-transclude></ng-transclude>" +
            "</div>" +
          "</div>" +
        "</div>";

      var controller = [
        "$scope",
        "$element",
        function ($scope, $element) {
          var ctl = this;

          ctl.boxWidthIsFluid = null;
          ctl.isOpen = false;
          ctl.isMouseDetected = false;
          ctl.$lastCalloutOrigin = undefined;

          $rootScope.$on("did-detect-mouse", function () {
            ctl.isMouseDetected = true;
          });

          function setBoxOffset(offset) {
            $element.find(".ty-tooltip-callout__box").css("left", offset);
          }

          ctl.updateBoxLeft = function () {
            if (!(ctl.$lastCalloutOrigin && ctl.$lastCalloutOrigin.length > 0)) {
              return;
            }

            const origin = $element.find(".ty-tooltip-callout__internal-origin").get(0);
            const box = $element.find(".ty-tooltip-callout__box").get(0);
            const externalOrigin = ctl.$lastCalloutOrigin.get(0);

            const viewportWidth = document.body.clientWidth;

            const calloutInternalOrigin = origin.getBoundingClientRect();
            const calloutExternalOrigin = externalOrigin.getBoundingClientRect();
            const calloutBoundingRect = box.getBoundingClientRect();
            const boxWidth = calloutBoundingRect.right - calloutBoundingRect.left;
            const boxHalfWidth = boxWidth / 2;

            // Useful coordinates within the viewport
            const boxDefaultRightEdge = calloutExternalOrigin.left + boxHalfWidth;
            const boxDefaultLeftEdge = calloutExternalOrigin.left - boxHalfWidth;
            const boxMinLeftEdge = TOOLTIP_CALLOUT_BOX_VIEWPORT_MARGIN;
            const boxMaxRightEdge = viewportWidth - TOOLTIP_CALLOUT_BOX_VIEWPORT_MARGIN;

            // Useful box offsets
            const preserveLeftViewportMargin = Math.max(boxMinLeftEdge - boxDefaultLeftEdge, 0);
            const preserveRightViewportMargin = Math.min(boxMaxRightEdge - boxDefaultRightEdge, 0);
            const keepCalloutNubWithinLeftBoxEdge =
              boxHalfWidth - (TOOLTIP_CALLOUT_NUB_WIDTH + TOOLTIP_CALLOUT_BOX_BORDER_RADIUS);
            const keepCalloutNubWithinRightBoxEdge =
              -boxHalfWidth + (TOOLTIP_CALLOUT_NUB_WIDTH + TOOLTIP_CALLOUT_BOX_BORDER_RADIUS);
            const justCentreTheBox = -calloutInternalOrigin.left + (viewportWidth - boxWidth) / 2;

            const isViewportTooNarrowForTooltip = viewportWidth < boxWidth + 2 * TOOLTIP_CALLOUT_BOX_VIEWPORT_MARGIN;

            if (isViewportTooNarrowForTooltip) {
              setBoxOffset(
                Math.max(Math.min(justCentreTheBox, keepCalloutNubWithinLeftBoxEdge), keepCalloutNubWithinRightBoxEdge)
              );
            } else {
              setBoxOffset(
                Math.min(preserveLeftViewportMargin, keepCalloutNubWithinLeftBoxEdge) +
                  Math.max(preserveRightViewportMargin, keepCalloutNubWithinRightBoxEdge)
              );
            }
          };

          function showImmediately($calloutOrigin) {
            ctl.$lastCalloutOrigin = $calloutOrigin;
            ctl.isOpen = true;

            ctl.$lastCalloutOrigin.append($element);

            $timeout(function () {
              ctl.updateBoxLeft();
            });
          }

          ctl.open = function ($newCalloutOrigin) {
            $timeout(function () {
              var $currentCalloutOrigin = $element.parent();

              // Are we moving an already-fading-out callout between elements? Need wait for it to fade out, then fade in at the new location.
              if ($currentCalloutOrigin.get(0) !== $newCalloutOrigin.get(0) && $element.hasClass("ng-hide-add")) {
                $timeout(function () {
                  showImmediately($newCalloutOrigin);
                }, TOOLTIP_FADEOUT_DURATION_MS);
              } else {
                showImmediately($newCalloutOrigin);
              }
            });
          };

          ctl.close = function () {
            $timeout(function () {
              ctl.isOpen = false;
            });
          };

          ctl.close();
        },
      ];

      return {
        restrict: "E",
        scope: {},
        bindToController: {
          tooltipCalloutId: "@",
        },
        controller: controller,
        controllerAs: "ctl",
        transclude: true,
        replace: true,
        template: template,
        link: function (scope, $element, attrs, ctrls, transcludeFn) {
          var tooltipCalloutTriggerSelector = '[href="#' + attrs.tooltipCalloutId + '"]';
          var tyTooltipCallout = scope.ctl;
          var $body = angular.element("body");
          var closeTimeout;

          function ensureCalloutOrigin($calloutTrigger) {
            var calloutOriginAttr = $calloutTrigger.attr("data-ty-tooltip-callout-origin-selector");
            var $calloutOrigin = calloutOriginAttr ? angular.element(calloutOriginAttr) : angular.element();

            if ($calloutOrigin.length) {
              return;
            }

            var calloutOriginId = "callout-origin-" + GenerateUuid();
            $calloutOrigin = angular.element(
              '<span id="' +
                calloutOriginId +
                '" class="ty-tooltip-trigger-container__callout-origin -top-center"></span>'
            );
            $calloutTrigger.attr("data-ty-tooltip-callout-origin-selector", "#" + calloutOriginId);

            var cssClasses = ["ty-tooltip-trigger-container"];
            var wrapperAddClass = $calloutTrigger.attr("data-ty-tooltip-trigger-container-add-class");

            if (wrapperAddClass) {
              cssClasses.push(wrapperAddClass);
            }

            var $wrapper = angular.element('<span class="' + cssClasses.join(" ") + '"></span>');
            $calloutTrigger.wrap($wrapper);
            $calloutOrigin.insertAfter($calloutTrigger);
          }

          function getCalloutOrigin($calloutTrigger) {
            return angular.element($calloutTrigger.attr("data-ty-tooltip-callout-origin-selector"));
          }

          function getClosestCalloutTrigger(el) {
            return angular.element(el).closest(tooltipCalloutTriggerSelector);
          }

          function init() {
            angular.element(tooltipCalloutTriggerSelector).each(function (index, el) {
              $timeout(function () {
                ensureCalloutOrigin(angular.element(el));
              });
            });

            // open on tap (touch devices)
            $body.on("click", tooltipCalloutTriggerSelector, function (event) {
              if (tyTooltipCallout.isMouseDetected) {
                event.preventDefault();
                return;
              }

              tyTooltipCallout.open(getCalloutOrigin(getClosestCalloutTrigger(event.target)));

              event.preventDefault();
            });

            // close on tap outside (touch devices)
            $body.on("click." + tyTooltipCallout.tooltipCalloutId, "*", function (event) {
              if (tyTooltipCallout.isMouseDetected || !tyTooltipCallout.isOpen) {
                return;
              }

              var $el = angular.element(event.target);
              if ($el.closest($element).length === 0) {
                tyTooltipCallout.close();
              }

              event.preventDefault();
            });

            // open on mouseenter (hover devices)
            function mouseEnterHandler(event) {
              if (!tyTooltipCallout.isMouseDetected) {
                return;
              }

              if (closeTimeout) {
                $timeout.cancel(closeTimeout);
              }

              tyTooltipCallout.open(
                getCalloutOrigin(getClosestCalloutTrigger(event.target)) || tyTooltipCallout.$lastCalloutOrigin
              );
            }

            $body.on("mouseenter", tooltipCalloutTriggerSelector, mouseEnterHandler);
            $element.on("mouseenter", mouseEnterHandler);

            // close on mouseleave
            function mouseLeaveHandler() {
              if (!tyTooltipCallout.isMouseDetected) {
                return;
              }

              if (closeTimeout) {
                $timeout.cancel(closeTimeout);
              }

              closeTimeout = $timeout(tyTooltipCallout.close, MOUSE_LEAVE_TOOLTIP_CLOSE_DELAY_MS);
            }

            $body.on("mouseleave", tooltipCalloutTriggerSelector, mouseLeaveHandler);
            $element.on("mouseleave", mouseLeaveHandler);

            CssMediaWatcher({
              $el: $element,
              pseudoEl: "before",
              mediaProperty: "viewportWidth",
              mediaRegexes: {
                mobile: "^mobile$",
                desktop: "^desktop$",
              },
            }).on("didInitOrChange", function (e, cssMedia) {
              tyTooltipCallout.boxWidthIsFluid = cssMedia.viewportWidth.is.mobile;
              tyTooltipCallout.updateBoxLeft();
            });

            angular.element($window).on("resize", tyTooltipCallout.updateBoxLeft);
          }

          transcludeFn(function (clone) {
            $element.find("ng-transclude").after(clone).remove();
          });

          init();
        },
      };
    },
  ]);
})(window.angular);
